module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<nav id="nav"></nav>\n<div id="content"></div>\n<div id="extra-content"></div>\n\n<div class="mobile-menu-overlay"></div>\n<button type="button" class="btn btn-menu-toggle" data-action="toggle-menu">\n    <span>Toggle menu</span>\n</button>';
}
return __p;
};